import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Splash extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        return <div> <Link to="/login"><h1>render for 5 seconds and then push to home</h1>
        </Link></div>
    }
}


export default Splash
